import { AvailabilityMap, InstructorDto } from '../../../service/types'

export const filterAvailableInstructors = (
  instructors: InstructorDto[],
  availabilityMap: AvailabilityMap,
  startTime: string,
  endTime: string,
): InstructorDto[] => {
  if (!startTime || !endTime) return instructors

  const startHour = parseInt(startTime.split(':')[0], 10)
  const endHour = parseInt(endTime.split(':')[0], 10)
  const endMin = parseInt(endTime.split(':')[1], 10)
  const lastNeededHour = endMin > 0 ? endHour : endHour - 1

  const neededHours: number[] = []
  for (let h = startHour; h <= lastNeededHour; h++) {
    neededHours.push(h)
  }

  if (neededHours.length === 0) return instructors

  return instructors.filter((inst) => {
    const hours = availabilityMap[inst.id]
    if (!hours) return false
    return neededHours.every((h) => hours.includes(h))
  })
}
